export default __webpack_public_path__ + "static/media/sunflowers.6bd0a6b5.jpg";